import React, {useState, useEffect} from "react";
import styles from "./ProductCard.module.css";
import {IProduct} from "../../../../services/model/Product";
import Details from "../details/details";
import { useNavigate } from "react-router-dom";


interface Props {
    product: IProduct;
    isOnSale?: boolean;
    discountedPrice?: string;
}

const ProductCard: React.FC<Props> = (props) => {


    const navigate = useNavigate();


    const handleViewDetailsClick = () => {
        // Better: use product.id (stable) instead of name (can change)
        navigate(`/details/${props.product.name}`, {
            state: { product: props.product }  // optional: for instant load
        });
    };


    return (
        <div style={{backgroundColor:"black"}}>
            <div className={styles.card}>
                {/*{props.isOnSale && (*/}
                {/* <div className={styles.badge}>HOT SALE</div>*/}
                {/*)}*/}

                <div className={styles.tilt}>
                    <div className={styles.img}>
                        <div className={styles.imageWrapper}>
                            <img
                                src={props.product.imageUrl[0]}
                                alt={props.product.name}
                            />
                        </div>
                    </div>
                </div>

                <div className={styles.info}>
                    <h2 className={styles.title}>{props.product.name}</h2>

                    <div className={styles.bottom}>
                        <div className={styles.price}>
                            {props.isOnSale ? (
                                <>
                                    <span className={styles.old}>${props.product.price.toFixed(2)}</span>
                                    {/*<span className={styles.new}>${props.discountedPrice}</span>*/}
                                </>
                            ) : (
                                <>${props.product.price.toFixed(2)}</>
                            )}
                        </div>

                        <button
                            className={styles.btn}
                            onClick={handleViewDetailsClick}
                        >
                            <span>View Details</span>
                        </button>
                    </div>

                    <div className={styles.meta}>
                        {/*<div className={styles.rating}>*/}
                        {/* {[1, 2, 3, 4, 5].map((i) => (*/}
                        {/* <svg*/}
                        {/* key={i}*/}
                        {/* width="16"*/}
                        {/* height="16"*/}
                        {/* viewBox="0 0 24 24"*/}
                        {/* fill="#FFD700"*/}
                        {/* stroke="#FFD700"*/}
                        {/* strokeWidth="0.5"*/}
                        {/* >*/}
                        {/* <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />*/}
                        {/* </svg>*/}
                        {/* ))}*/}
                        {/* <span className={styles.rcount}>245 Reviews</span>*/}
                        {/*</div>*/}

                        {props.product.isAvailable ?
                            <div className={styles.inStock}>In Stock</div>  :
                            <div className={styles.outStock}>Out of Stock</div>}
                    </div>
                </div>
            </div>

        </div>
    );
};

export default ProductCard;